export const APP_DEFAULTS = {
    sites: [
      // Larzac / Vis
      {
        id: "site-larzac-1",
        name: "Cirque de Navacelles",
        description: "Un canyon spectaculaire creusé par la Vis, offrant des panoramas à couper le souffle au cœur des Causses et des Cévennes.",
        location: { lat: 43.891, lng: 3.511 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Panorama", "UNESCO", "Incontournable"],
        isPaid: false,
        entryPrice: 0,
        sector: "Larzac / Vis",
        category: "nature"
      },
      {
        id: "site-larzac-2",
        name: "St-Guilhem-le-Désert",
        description: "L'un des plus beaux villages de France, étape majeure sur le chemin de St-Jacques de Compostelle.",
        location: { lat: 43.734, lng: 3.549 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Village", "UNESCO", "Incontournable"],
        isPaid: false,
        entryPrice: 0,
        sector: "Larzac / Vis",
        category: "patrimoine"
      },
      {
        id: "site-larzac-3",
        name: "Belvédère de Blandas",
        description: "Une vue imprenable sur le Cirque de Navacelles depuis le causse de Blandas.",
        location: { lat: 43.912, lng: 3.515 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Panorama", "Nature", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Larzac / Vis",
        category: "nature"
      },
      {
        id: "site-larzac-4",
        name: "Fermes de Pélardon",
        description: "Découvrez la fabrication du célèbre fromage de chèvre des Cévennes dans une ferme traditionnelle.",
        location: { lat: 43.923, lng: 3.555 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Gastronomie", "Ferme", "Pépite"],
        isPaid: true,
        entryPrice: 5,
        sector: "Larzac / Vis",
        category: "insolite",
        isFarm: true
      },
      {
        id: "site-larzac-5",
        name: "Restaurant - Les belvédères de Blandas",
        description: "Restaurant offrant une vue panoramique exceptionnelle sur le Cirque de Navacelles depuis le causse de Blandas.",
        location: { lat: 43.912, lng: 3.515 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Gastronomie", "Panorama", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Larzac / Vis",
        category: "restaurations",
        cateringType: "restaurant"
      },
      // Cévennes / Anduze
      {
        id: "site-anduze-1",
        name: "Bambouseraie en Cévennes",
        description: "Un jardin exotique unique en Europe, célèbre pour sa forêt de bambous géants.",
        location: { lat: 44.071, lng: 3.985 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Jardin", "Incontournable"],
        isPaid: true,
        entryPrice: 12,
        sector: "Cévennes / Anduze",
        category: "nature"
      },
      {
        id: "site-anduze-2",
        name: "Train à Vapeur des Cévennes",
        description: "Voyagez à travers les paysages cévenols à bord d'un authentique train à vapeur.",
        location: { lat: 44.053, lng: 3.992 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Train", "Incontournable"],
        isPaid: true,
        entryPrice: 15,
        sector: "Cévennes / Anduze",
        category: "patrimoine"
      },
      {
        id: "site-anduze-3",
        name: "Grotte de Trabuc",
        description: "Explorez la grotte aux 100 000 soldats, un joyau souterrain des Cévennes.",
        location: { lat: 44.095, lng: 3.895 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Grotte", "Pépite"],
        isPaid: true,
        entryPrice: 10,
        sector: "Cévennes / Anduze",
        category: "nature"
      },
      {
        id: "site-anduze-4",
        name: "Poteries d'Anduze",
        description: "Découvrez l'artisanat local des célèbres vases d'Anduze.",
        location: { lat: 44.051, lng: 3.988 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Artisanat", "Village", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Cévennes / Anduze",
        category: "patrimoine"
      },
      // Gorges de l'Hérault
      {
        id: "site-herault-1",
        name: "Grotte des Demoiselles",
        description: "Une cathédrale souterraine spectaculaire, accessible par un funiculaire.",
        location: { lat: 43.928, lng: 3.731 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Grotte", "Incontournable"],
        isPaid: true,
        entryPrice: 13,
        sector: "Gorges de l'Hérault",
        category: "nature"
      },
      {
        id: "site-herault-2",
        name: "Pont du Diable",
        description: "Un pont médiéval classé à l'UNESCO, surplombant les gorges de l'Hérault.",
        location: { lat: 43.728, lng: 3.555 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Nature", "UNESCO"],
        isPaid: false,
        entryPrice: 0,
        sector: "Gorges de l'Hérault",
        category: "patrimoine"
      },
      {
        id: "site-herault-3",
        name: "Abbaye de Gellone",
        description: "Une abbaye romane majeure, joyau de l'art roman en Languedoc.",
        location: { lat: 43.734, lng: 3.549 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Patrimoine", "UNESCO"],
        isPaid: false,
        entryPrice: 0,
        sector: "Gorges de l'Hérault",
        category: "patrimoine"
      },
      {
        id: "site-herault-4",
        name: "Lac du Salagou",
        description: "Un lac aux eaux turquoises entouré de terres rouges, idéal pour la détente.",
        location: { lat: 43.655, lng: 3.335 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Loisirs", "Panorama"],
        isPaid: false,
        entryPrice: 0,
        sector: "Gorges de l'Hérault",
        category: "nature"
      },
      // Littoral / Salagou
      {
        id: "site-littoral-1",
        name: "Aigues-Mortes",
        description: "Une cité médiévale fortifiée au cœur de la Camargue.",
        location: { lat: 43.565, lng: 4.191 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Village", "Incontournable"],
        isPaid: false,
        entryPrice: 0,
        sector: "Littoral / Salagou",
        category: "patrimoine"
      },
      {
        id: "site-littoral-2",
        name: "Sète",
        description: "La Venise languedocienne, célèbre pour son port et ses canaux.",
        location: { lat: 43.405, lng: 3.691 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Ville", "Port", "Gastronomie"],
        isPaid: false,
        entryPrice: 0,
        sector: "Littoral / Salagou",
        category: "patrimoine"
      },
      {
        id: "site-littoral-3",
        name: "Salins du Midi",
        description: "Découvrez la récolte du sel dans les salins de Camargue.",
        location: { lat: 43.555, lng: 4.185 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Insolite", "Pépite"],
        isPaid: true,
        entryPrice: 10,
        sector: "Littoral / Salagou",
        category: "nature"
      },
      {
        id: "site-littoral-4",
        name: "Plage de l'Espiguette",
        description: "Une immense plage sauvage de sable fin.",
        location: { lat: 43.515, lng: 4.135 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Loisirs", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Littoral / Salagou",
        category: "nature"
      },
      // Romain / Uzès
      {
        id: "site-romain-1",
        name: "Pont du Gard",
        description: "Un chef-d'œuvre de l'architecture romaine, classé à l'UNESCO.",
        location: { lat: 43.948, lng: 4.538 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "UNESCO", "Incontournable"],
        isPaid: true,
        entryPrice: 9,
        sector: "Romain / Uzès",
        category: "patrimoine"
      },
      {
        id: "site-romain-2",
        name: "Arènes de Nîmes",
        description: "Un amphithéâtre romain exceptionnellement bien conservé.",
        location: { lat: 43.833, lng: 4.360 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Patrimoine", "Incontournable"],
        isPaid: true,
        entryPrice: 10,
        sector: "Romain / Uzès",
        category: "patrimoine"
      },
      {
        id: "site-romain-3",
        name: "Uzès",
        description: "Une ville d'art et d'histoire, célèbre pour son marché et son duché.",
        location: { lat: 44.011, lng: 4.419 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Histoire", "Village", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Romain / Uzès",
        category: "patrimoine"
      },
      {
        id: "site-romain-4",
        name: "Jardin des Oules",
        description: "Un jardin remarquable situé à proximité d'Uzès.",
        location: { lat: 44.025, lng: 4.435 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Jardin", "Pépite"],
        isPaid: true,
        entryPrice: 6,
        sector: "Romain / Uzès",
        category: "nature"
      },
      // Massif de l'Aigoual
      {
        id: "site-aigoual-1",
        name: "Observatoire de l'Aigoual",
        description: "Le dernier observatoire météorologique de montagne en activité en France.",
        location: { lat: 44.123, lng: 3.581 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Panorama", "Incontournable"],
        isPaid: false,
        entryPrice: 0,
        sector: "Massif de l'Aigoual",
        category: "nature"
      },
      {
        id: "site-aigoual-2",
        name: "Abîme de Bramabiau",
        description: "Une grotte spectaculaire où la rivière Bonheur surgit de la montagne.",
        location: { lat: 44.135, lng: 3.535 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Grotte", "Pépite"],
        isPaid: true,
        entryPrice: 11,
        sector: "Massif de l'Aigoual",
        category: "nature"
      },
      {
        id: "site-aigoual-3",
        name: "Forêt du Lingas",
        description: "Une forêt majestueuse au cœur des Cévennes.",
        location: { lat: 44.115, lng: 3.555 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Randonnée", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Massif de l'Aigoual",
        category: "nature"
      },
      {
        id: "site-aigoual-4",
        name: "Cascade d'Assas",
        description: "Une cascade pittoresque dans un cadre naturel préservé.",
        location: { lat: 44.105, lng: 3.525 },
        image: "https://images.unsplash.com/photo-1596436889106-be35e843f974?auto=format&fit=crop&w=800&q=80",
        tags: ["Nature", "Panorama", "Pépite"],
        isPaid: false,
        entryPrice: 0,
        sector: "Massif de l'Aigoual",
        category: "nature"
      }
    ],
    legalMentions: "Mentions Légales - Céven'VTC\n...",
    cgv: "Conditions Générales de Vente (CGV) - Céven'VTC\n...",
    bookings: [],
    users: [],
    packs: [],
    driverLocation: { lat: 43.923, lng: 3.847 },
    customerLocation: null,
    activeBooking: null,
    settings: { 
      kmRate: 2.15, 
      highwayTolls: true, 
      maxDailyKm: 250,
      companyName: "Céven'VTC",
      email: "ceven.vtc@gmail.com",
      phone: "06 00 00 00 00",
      vehicle: "Peugeot 5008 (7 places, Bleu Bourrasque)",
      driverExperience: "34 ans de permis",
      siret: "123 456 789 00012",
      baseAddress: "Cazilhac 34190",
      nightRateIncrease: 35,
      nightStart: "19:00",
      nightEnd: "07:00",
      discountThreshold: 110,
      discountPercentage: 10,
      heroImageLastUpdate: 0,
      adminEmail: 'gerald.verdier@gmail.com',
      driverHomeAddress: 'Cazilhac 34190, France',
      heroImageId: 'route-cevennes',
      heroVtcGlassEffect: false,
      touristCircuitsTitle: 'Découvrez les Cévennes autrement',
      touristCircuitsText: 'Profitez du confort de notre Peugeot 5008 Bleu et de notre expertise locale pour un circuit inoubliable.',
      tourMaxKm: 200,
      tourReturnTime: "19:00",
      tourMaxDurationHalfDay: 5,
      tourMaxDurationFullDay: 10,
      tourPriceFullDay: 280,
      tourPriceHalfDay: 175,
      sectorConfigs: {
        "Larzac / Vis": {
          title: "L'Épopée du Larzac",
          description: "Explorez les paysages grandioses du Larzac et la majesté du Cirque de Navacelles."
        },
        "Cévennes / Anduze": {
          title: "Le Cœur des Cévennes",
          description: "Découvrez l'authenticité d'Anduze et la magie de la Bambouseraie."
        },
        "Gorges de l'Hérault": {
          title: "La Vallée des Demoiselles",
          description: "Plongez dans les profondeurs de la Grotte des Demoiselles et les eaux de l'Hérault."
        },
        "Littoral / Salagou": {
          title: "Terres Rouges & Mer Bleue",
          description: "Du paysage lunaire du Salagou aux canaux pittoresques de Sète."
        },
        "Romain / Uzès": {
          title: "L'Épopée Romaine",
          description: "Voyagez dans le temps du Pont du Gard aux Arènes de Nîmes."
        },
        "Massif de l'Aigoual": {
          title: "Le Toit des Cévennes",
          description: "Prenez de la hauteur à l'Observatoire de l'Aigoual et respirez le grand air."
        }
      },
      legalMentions: `Mentions Légales - Céven'VTC`,
      cgv: `Conditions Générales de Vente (CGV) - Céven'VTC`
    }
};
